import 'css-chunk:src/applications/ReportsApp/pages/Reporting/components/PageLoading/PageLoading.scss';export default {
  "ChartLoading": "_ChartLoading_1v7ac_1",
  "TrendLoading": "_TrendLoading_1v7ac_10",
  "AlertLoading": "_AlertLoading_1v7ac_16",
  "MetricTab": "_MetricTab_1v7ac_24",
  "Divider": "_Divider_1v7ac_35"
};